// extracted by css-extract-rspack-plugin
export default {"AppPassword":"AppPassword-lgRpUa","appPassword":"AppPassword-lgRpUa"};